import { useState, useEffect } from 'react';
import { Card, Image, Carousel, Spin } from 'antd';
import { supabase } from './supabaseClient';

const STORAGE_URL = 'https://ufqlvqoaghopavqggahm.supabase.co/storage/v1/object/public/car-images';

function CarListings() {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchCars() {
      const { data: carsData, error: carsError } = await supabase
        .from('cars')
        .select('id, year, make, model, salePrice, features')
        .eq('onWeb', true)
        .neq('state', 'Sold')
        .order('id');

      if (carsError) {
        console.error('Error fetching cars:', carsError);
        setLoading(false);
        return;
      }

      const webCarIds = carsData.map((car) => car.id);
      const { data: imagesData, error: imagesError } = await supabase
        .from('car_images')
        .select('car_id, storage_path, display_path, display_order')
        .in('car_id', webCarIds)
        .order('display_order');

      if (imagesError) {
        console.error('Error fetching images:', imagesError);
      }

      const imagesByCarId = {};
      if (imagesData) {
        imagesData.forEach((img) => {
          if (!imagesByCarId[img.car_id]) {
            imagesByCarId[img.car_id] = [];
          }
          imagesByCarId[img.car_id].push({
            // display_path is null for images uploaded before variants existed.
            display: img.display_path || img.storage_path,
            full: img.storage_path,
          });
        });
      }

      const carsWithImages = carsData
        .map((car) => ({
          ...car,
          images: imagesByCarId[car.id] || [],
        }))
        .filter((car) => car.images.length > 0);

      setCars(carsWithImages);
      setLoading(false);
    }

    fetchCars();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 40 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      {cars.map((car) => {
        const price = car.salePrice
          ? `- $${Number(car.salePrice).toLocaleString()}`
          : '';
        const title = `${car.year} ${car.make} ${car.model} ${price}`;

        return (
          <Card
            key={car.id}
            title={title}
            variant="borderless"
            style={{ width: 500 }}
          >
            {car.features && <p>{car.features}</p>}
            {car.images.length > 0 && (
              <Carousel arrows infinite={true} lazyLoad="ondemand">
                {car.images.map((img, i) => (
                  <div key={i}>
                    <Image
                      width={500}
                      src={`${STORAGE_URL}/${img.display}`}
                      preview={{ src: `${STORAGE_URL}/${img.full}` }}
                    />
                  </div>
                ))}
              </Carousel>
            )}
          </Card>
        );
      })}
    </>
  );
}

export default CarListings;
